<template>
  <div>
    <b-button
      type="is-primary"
      :size="btn_size"
      icon-left="plus-circle-outline"
      @click="addItem()"
      :disabled="isDisabled"
      :loading="isDisabled"
      >AGREGAR</b-button
    >
  </div>
</template>

<script>
import AppMappers from "@/store/app-global-mappers";
import CartApi from "@/api/cart";

export default {
  name: "AddToCart",
  mixins: [AppMappers, CartApi],
  props: ["data", "size", "silent"],
  data() {
    return {
      product: null,
      isDisabled: false,
      btn_size: "is-default",
      is_silent: false,
    };
  },
  created() {
    this.product = this.data;
    if (this.size) {
      this.btn_size = this.size;
    }
    if (this.silent) {
      this.is_silent = this.silent;
    }
  },
  mounted() {
    //console.log("Received data", this.product)
  },
  methods: {
    addItem() {
      let self = this;

      let payload = {
        img: this.product.img,
        quantity: 1,
        code: this.product.code,
        description: this.product.full_title
          ? this.product.full_title
          : this.product.title,
        unitary_price: this.product.price,
        stock: this.product.stock,
        current_price: this.product.current_price,
      };

      if (this.product.current_price.has_discount) {
        payload.unitary_price = this.product.current_price.discount_value;
      }

      if (this.product.cart_suggestions) {
        payload.cart_suggestions = this.product.cart_suggestions;
      }

      self.isDisabled = true;
      this.api_post("push_item", payload, (response) => {
        console.log(response);

        self.isDisabled = false;
        if (response) {
          self.fireCartChange({
            item_count: response.item_count,
            order_subtotal: response.order_subtotal,
            order_total: response.order_total,
          });

          let title = self.product.full_title
            ? self.product.full_title
            : self.product.title;

          if (self.is_silent) {
            self.$emit("pushed");
            return this.$buefy.dialog.alert({
              message: `¡Listo! Agregamos <b class="has-text-primary">${self.product.title}</b> a tu carrito.`,
              type: "is-success",
              hasIcon: true,
              ariaRole: "alertdialog",
              ariaModal: true,
            });
          } else {
            self.$emit("pushed");
            return this.$buefy.dialog.confirm({
              type: "is-success",
              hasIcon: true,
              message: `¡Listo! Agregamos <b class="has-text-primary">${self.product.title}</b> a tu carrito.`,
              cancelText: "Seguir navegando",
              confirmText: "Ir al carrito",
              onConfirm: () => window.location.replace("/mi-carrito/ver"),
            });
          }
        }

        this.$buefy.dialog.alert({
          message:
            "Algo salió mal. Por favor intenta más tarde o ponte en contacto con nosotros si el problema persiste.",
          type: "is-danger",
          hasIcon: true,
          ariaRole: "alertdialog",
          ariaModal: true,
        });
      });
    },
  },
};
</script>